import * as React from 'react';
import classnames from 'classnames';
import { Eye } from 'lucide-react';
import { t } from '~i18n';
import styles from './ViewOnlyChip.module.css';

export interface ViewOnlyChipProps {
  /** Site whose alarms the user handles instead — named in the tooltip when
   *  they're on duty somewhere. Absent when they're not on duty at all. */
  dutySiteName?: string;
  className?: string;
}

/** States what you can do at the site you're *viewing*, sat next to the site
 *  switcher it describes. Shown whenever the viewed site isn't the one you
 *  handle — including when you handle none — so read-only is never left to be
 *  inferred from a status pill that names a different site. */
const ViewOnlyChip: React.FC<ViewOnlyChipProps> = ({ dutySiteName, className }) => (
  <span
    className={classnames(styles.Chip, className)}
    title={dutySiteName ? t('alertMode.viewOnlyHere.hint', { site: dutySiteName }) : t('alertMode.viewOnly.tagHere')}
  >
    <Eye size={13} aria-hidden="true" />
    <span>{t('alertMode.viewOnly.tag')}</span>
  </span>
);

export default ViewOnlyChip;
